import { simbaStyled } from '@naf-simba/theme';

export const SectionContainer = simbaStyled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  marginBottom: theme.spacing('4xl'),
}));
